import React from 'react'

export default function Select ({ error = false, className = '', children, ...props }) {
  return <select className={`ui-select ${className}`.trim()} aria-invalid={error || undefined} {...props}>{children}</select>
}
